export const apiUrl = "https://apicsd.nelumbo.com.co/api/"; //Qa
export const recaptchaKey = "6Lc43jgeAAAAAGyrCW2uTrKF0RP-XdR0Wb0gkjne"; // QA

// export const apiUrl = "https://apicsddev.nelumbo.com.co/api/"; //DEV
// export const recaptchaKey = "6LeIx-weAAAAAOcmR8O_0rLfZlsWm9eUVKXQvzLZ"; //DEV
